import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { AppShell } from '@/components/layout/app-shell'
import { meQuery } from '@/api/auth'
import { ApiError } from '@/api/errors'

/**
 * Pathless layout route `/_authed` — every authed page lives under here.
 *
 * `beforeLoad` is the single gate: if `/api/me` returns 401 (or any
 * other error we treat as "not logged in"), redirect to /login with
 * `from=<current path>` so the login page can bounce back on success.
 *
 * Once we reach the component, `meQuery` is guaranteed cached, so
 * children can `useSuspenseQuery(meQuery())` safely.
 */
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(meQuery())
    } catch (err) {
      if (err instanceof ApiError && err.isUnauthorized) {
        throw redirect({
          to: '/login',
          search: { from: location.pathname + location.searchStr },
        })
      }
      throw err
    }
  },
  component: AuthedLayout,
})

function AuthedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
